import { defineStore } from "pinia";
import Api from "@/helpers/api";
import { loading, closeLoding, notify } from "@/helpers/$vs.js";
import * as Forms from "./Forms";

export const useFormsListStore = defineStore("formsList", {
  state: () => ({
    state: 1,
    listForms: [],
    loading: false  
  }),
  actions: {
    async getAllForms() {
      try {
        this.loading = false;
        loading();
        const result = await Forms.getAllForms();
        this.listForms = result;
      } catch (error) {
        console.error("getAllForms Error:", error);
        const message = error.data !== null ? error.data.hasOwnProperty('reason')? error.data.reason: `${error.error}`: `${error.error}`;
        let text = "";
        
        if (message === "Forms are empty") text = `No hay formularios registrados.`;

        notify("Lista de Formularios", text, "warning");
        this.listForms = [];
      }finally { closeLoding(); this.loading = true; }
    }, 
    
    State(estado){ this.state = estado }
      
  },
  getters: {
    _listForms(state) {
      return state.listForms.filter(form => {
        if(state.state === 1) return form.status === 'Active';
        if(state.state === 2) return form.status === 'Deleted';
        return true;
      });
    }
  }
});
